const loginUser = (request) => {
    return new Promise((res, rej) => {
        axios.post('login', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};
const logout = (request) => {
    return new Promise((res, rej) => {
        axios.get('logout', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};
const getConsumerStatus = (request) => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        axios.post('getconsumerstatus', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};
const consumerAccountVerifyCode = (request) => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        axios.post('consumeraccountverifycode', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const consumerAccountVerifyCodeResend = (request) => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        axios.post('consumersendverificationcode', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const checkStateAge = (request) => {
    return new Promise((res, rej) => {
        axios.post('checkstateage', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const webauthnLoginOptions = (request) => {
    return new Promise((res, rej) => {
        axios.post('webauthn/login/options', request)
            .then((response) => res(response.data))
            .catch((err) => rej(err));
    });
};

const webauthnLogin = (request) => {
    return new Promise((res, rej) => {
        axios.post('webauthn/login', request)
            .then((response) => res(response.data))
            .catch((err) => rej(err));
    });
};

const webauthnRegisterOptions = () => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        axios.post('webauthn/register/options')
            .then((response) => res(response.data))
            .catch((err) => rej(err));
    });
};

const webauthnStatus = (request) => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        axios.post('webauthn/status', request)
            .then((response) => res(response.data))
            .catch((err) => rej(err));
    });
};

const webauthnRegister = (request) => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        axios.post('webauthn/register', request)
            .then((response) => res(response.data))
            .catch((err) => rej(err));
    });
};

const webauthnRemove = (request) => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        axios.post('webauthn/remove', request)
            .then((response) => res(response.data))
            .catch((err) => rej(err));
    });
};

const skipPasskeyPrompt = (request) => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        axios.post('webauthn/prompt/skip', request)
            .then((response) => res(response.data))
            .catch((err) => rej(err));
    });
};


export default {
    loginUser,
    logout,
    getConsumerStatus,
    consumerAccountVerifyCodeResend,
    consumerAccountVerifyCode,
    checkStateAge,
    webauthnLoginOptions,
    webauthnLogin,
    webauthnRegisterOptions,
    webauthnStatus,
    webauthnRegister,
    webauthnRemove,
    skipPasskeyPrompt
};
